import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppConfig } from "../visa";
import { SubSink } from "subsink2";
import { ClientSidePermissionsSelectors } from "../modules/permission/client-side-permissions-controller/selectors";
import { ClientSideViewModel } from "../modules/permission/client-side-permissions-controller/states/client-side-permission.states";
import { PermissionStates } from "../modules/permission/permission-controller/root";
import { SessionSelectors } from "../modules/session/session-controller/selectors";
import { SessionStates } from "../modules/session/session-controller/states";

@Directive({
  selector: '[appPermissionHide]'
})
export class PermissionHideDirective implements OnInit, OnDestroy {
  private userPermissions: ClientSideViewModel[] = [];
  private checkPerm = '';

  apiVisa = AppConfig.apiVisa;
  userRank: string;

  private subs = new SubSink();


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cd: ChangeDetectorRef,
    private readonly permissionStore: Store<PermissionStates>,
    private readonly sessionStore: Store<SessionStates>
  ) {
  }

  ngOnInit() {
    this.subs.sink = this.permissionStore.select(ClientSidePermissionsSelectors.selectAll).subscribe({
      next: resolve => this.userPermissions = resolve
    });

    this.subs.sink = this.sessionStore.select(SessionSelectors.selectAppletLoginSubjectLink).subscribe({
      next: resolve => this.userRank = resolve.rank.toString()
    });

    this.updateView();
  }

  @Input()
  set appPermissionHide(val: string) {
    this.checkPerm = val;
  }

  private updateView() {
    if (this.checkPermission()) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    this.cd.markForCheck();
  }

  private checkPermission() {
    return this.isOwner() || this.isAdmin() || this.userPermissions.find(perm => perm.perm_code.toUpperCase() === this.checkPerm.toUpperCase())
  }

  private isOwner() {
    return this.userRank ? this.userRank?.toUpperCase() === "OWNER" : false;
  }

  private isAdmin() {
    return this.userRank ? this.userRank?.toUpperCase() === "ADMIN" : false;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
